import { classes } from 'html-classes';
import { sortBy } from 'lodash-es';

import Icon from '~/components/Icon/Icon';
import { IconTypes } from '~/components/Icon/IconTypes';
import { useGlobal } from '~/hooks/useGlobal';

import { SEO_ITEMS } from './constants';
import styles from './FooterSEOSection.module.scss';
import { FooterSEOSectionProps } from './interfaces';

const FooterSEOSection = ({ className }: FooterSEOSectionProps) => {
  const { isMobile } = useGlobal();

  return (
    <div className={classes([styles.root, className])}>
      {sortBy(SEO_ITEMS, 'order').map(({ title, caption, icon, captions }) => (
        <section key={title} className={styles.section}>
          <div className={styles.titleWr}>
            {icon && !isMobile && <Icon type={icon as IconTypes} size={24} />}
            <h3>{title}</h3>
          </div>
          <div className={styles.content}>
            <p>{caption || captions?.join('\n')}</p>
          </div>
        </section>
      ))}
    </div>
  );
};

export default FooterSEOSection;
